import { render, staticRenderFns } from "./VaultConfig.vue?vue&type=template&id=b46d8f18&scoped=true&"
import script from "./VaultConfig.vue?vue&type=script&lang=js&"
export * from "./VaultConfig.vue?vue&type=script&lang=js&"
import style0 from "./VaultConfig.vue?vue&type=style&index=0&id=b46d8f18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b46d8f18",
  null
  
)

export default component.exports